// extracted by mini-css-extract-plugin
export var button = "_nt-2";
export var card = "_nt-0";
export var closeButtonContainer = "_nt-3";
export var iconContainer = "_nt-1";